import { render, staticRenderFns } from "./TaxesList.vue?vue&type=template&id=f9f2a0be"
import script from "./TaxesList.vue?vue&type=script&lang=js"
export * from "./TaxesList.vue?vue&type=script&lang=js"
import style0 from "./TaxesList.vue?vue&type=style&index=0&id=f9f2a0be&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports